export enum WEBSOCKET_VIRTUAL_EVENT_COMMAND {
  UPDATE_CAMPAIGN = 1,
  UPDATE_BID = 3,
  UPDATE_TOTAL = 4,
  UPDATE_RUN_STATUS = 5,
  RECENT_ACTIVITY = 7,
  SEND_MESSAGE = 8,
  WINNING_BID = 9,
  WINNING_LAST_HERO = 10,
  UPDATE_CAMPAIGN_LIST = 11,
  SHOW_LIVE_AUCTION_MULTI = 12,
  PRESENTATION_MODE_FULL_SCREEN_VIDEO = 13,
  DELETE_CHAT_ITEM = 14
};

export enum VIRTUAL_EVENT_STATUS {
  LOBBY = 0,
  START = 1,
  END = 2
}

export enum CAMPAIGN_TYPE {
  DONATE = 0,
  MERCHANDISE = 1,
  HINDU_TEMPLE_PUJA = 3,
  AUCTION = 4,
  PARTY_SIGNUP = 5,
  TICKETING = 6,
  LONG_PLEDGE = 7,
  PEER_TO_PEER = 8,
  LAST_HERO = 9,
  IN_KIND = 10
}

export enum CAMPAIGN_TYPE_NAME {
  NONE = "None",
  DONATION = "Donation",
  MERCHANDISE = "Merchandise",
  SILENT_AUCTION = "Silent Auction",
  LIVE_AUCTION = "Live Auction",
  PARTY_SIGNUP = "Party Signup",
  LAST_HERO = "Last Hero",
  HINDU_TEMPLE_PUJA = "Puja",
  LONG_PLEDGE = "Long Pledge",
  PEER_TO_PEER = "Peer to Peer",
  TICKETING = "Ticketing",
  IN_KIND = "In-Kind"
}

export enum ACTIVITY_TYPE {
  PLEDGE = 0,
  BID = 1,
  DECLARE_WINNER = 2,
  DECLARE_LAST_HERO = 3,
  CAMPAIGN_CHANGE = 4,
  SILENT_AUCTION_CLOSED = 5,
  SELL_MORE = 6,
  RECURRING = 7
}

export enum AUCTION_TYPE {
  SILENT = 0,
  LIVE = 1
}

export enum AUCTION_STATUS {
  FINALIZED = 2
}

export enum ERRORS {
  AuctionItemAlreadySold = "This item has already been sold",
  NoLastManTransactionsPresent = "No pledges present for this campaign",
  AuctionNotClosedYet = "Auction not closed yet",
  UserAlreadyExist = "Account with this Email already exist, please try signin in",
  HandleAlreadyExist = "Handle already taken choose another",
  InvalidTaxId = "Invalid Tax Id",
  InvalidLast4SSN = "Invalid Last 4 SSN",
  InvalidCoupon = "Invalid Coupon",
  CouponNotYetActive = "Coupon Not Yet Active",
  CouponExpired = "Coupon Expired",
  RedeemedTooManyTimes = "Redeem Too Many Times",
  noTicketsForCampaign = 'No tickets for Campaign',
  AuctionClosed = 'Bidding for this item has ended',
  AuctionItemSoldOut = 'This item is sold out, bids are not accepted any more.',
  LessThanCurrentBidMax = 'Next allowed bid is more than the bid amount.',
  LessThanBidMin = 'Less than current or starting bid.',
  SameOrLessMaxBidAmount = 'Amount must be higher than your current Max Bid Amount.',
}

export enum AMOUNT_LIMIT {
  GLOBAL_MAX = 5000000,              
  GLOBAL_MAX_STR = "$5,000,000",     
  ORG_MAX = 5000000,                
  ORG_MAX_STR = "$5,000,000",      
  MIN = 1,                          
  MIN_STR = "$1",                 
}